export default __webpack_public_path__ + "static/media/compliances.53760157.svg";